/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on SILK-LICENSE
 */
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client'
import merge from 'lodash/merge'

import { typePolicies } from './policies'

import createBCLink from './bcLink'

let apolloClient = null

/**
 * Creates and configures the ApolloClient
 * @param {Object} reduxState
 */
const createApolloClient = () => {
  const bcLink = createBCLink()

  return new ApolloClient({
    // Routes the query to the proper client
    link: ApolloLink.from([bcLink]),
    cache: new InMemoryCache({
      addTypename: false,
      typePolicies
    }).restore({}),
    defaultOptions: {
      query: {
        fetchPolicy: 'cache-first'
      }
    }
  })
}

/**
 * Always creates a new apollo client on the server
 * Creates or reuses apollo client in the browser.
 * @param  {Object} apolloState
 * @param  {Object} cookies
 * @param  {Object} reduxState
 */
export const initApollo = ({ apolloState = {}}) => {
  const _apolloClient =
    apolloClient ??
    createApolloClient()

  // If your page has Next.js data fetching methods that use Apollo Client, the initial state
  // gets hydrated here
  if (apolloState) {
    // Get existing cache, loaded during client side data fetching
    const existingCache = _apolloClient.extract()

    // Merge the existing cache into data passed from getStaticProps/getServerSideProps
    const data = merge(apolloState, existingCache)

    // Restore the cache with the merged data
    _apolloClient.cache.restore(data)
  }

  if (!apolloClient) apolloClient = _apolloClient

  return _apolloClient
}
